var map = {
	"./childrensDay-land-page.png": 758,
	"./likes-img.png": 756,
	"./likes-imgx.png": 2442,
	"./mask-close.png": 647,
	"./mask-close1.png": 2443,
	"./share-get-zan.png": 653,
	"./share-invite.png": 652,
	"./shop1.png": 759,
	"./shop2.png": 760,
	"./tab0.png": 2444,
	"./tab1.png": 2445,
	"./tab2.png": 2446,
	"./zan-now.png": 757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2441;